import React from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { createRouter, wsTrpcClient } from '@/app/router';
import { auth } from '@/lib';
import { useAuth } from '@/lib';

const router = createRouter();

export function RouterWithAuth() {
    const { sessionData, isLoading } = useAuth()

    // Use router's default context which already injects Better Auth client (see app/router.tsx)
    // Pass only minimal shape to satisfy router context typing
    return <RouterProvider router={router} context={{ auth: { data: sessionData, isPending: isLoading } }} />;
}